/**
 * Creates a function that memoizes the result of a `function`.
 *
 * See:
 * https://www.npmjs.com/package/memize
 */
export { default as memoize } from 'memize';